module.exports = __webpack_public_path__ + "img/110.7.3ee1a6b2.png";